import core from './commuCore'
const output = {}

/* ----------------------- ppt元素相关api ----------------------- */
function getSlideById (condition) {
  return core.ajax(condition, '/element', 'get')
}
output.getSlideById = getSlideById

function saveSlide (condition) {
  return core.ajax(condition, '/element', 'post')
}
output.saveSlide = saveSlide

function tableOcr (image) {
  return core.ajax(image, '/element/tableOcr', 'post')
}
output.tableOcr = tableOcr
export default output
